import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { subscribeNewsletter, updateField } from '../../ducks/newsletterSubscription.duck';
import { useDispatch } from 'react-redux';
import AppleLogin from 'react-apple-login';
import { ReactComponent as AppleIcon } from '../../assets/icons/apple.svg';

import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { apiBaseUrl, checkUserExistApi } from '../../util/api';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { ensureCurrentUser } from '../../util/data';
import {
  isSignupEmailTakenError,
  isTooManyEmailVerificationRequestsError,
} from '../../util/errors';
import { pickUserFieldsData, addScopePrefix } from '../../util/userHelpers';

import { login, authenticationInProgress, signup, signupWithIdp, signupWithAppleIdp, loginWithAppleIdp, checkAppleMailId } from '../../ducks/auth.duck';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { sendVerificationEmail } from '../../ducks/user.duck';

import { ReactComponent as GoogleIcon } from '../../assets/icons/google.svg';

import {
  Page,
  Heading,
  IconSpinner,
  NamedRedirect,
  LinkTabNavHorizontal,
  SocialLoginButton,
  ResponsiveBackgroundImageContainer,
  LayoutSingleColumn,
  Modal,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import TermsAndConditions from './TermsAndConditions/TermsAndConditions';
import ConfirmSignupForm from './ConfirmSignupForm/ConfirmSignupForm';
import LoginForm from './LoginForm/LoginForm';
import SignupForm from './SignupForm/SignupForm';
import EmailVerificationInfo from './EmailVerificationInfo';

import NotFoundPage from '../NotFoundPage/NotFoundPage';

import css from './AuthenticationPage.module.css';
import { FacebookLogo, GoogleLogo } from './socialLoginLogos';
import Footer from '../../components/Cobe/Footer/Footer';
import routeConfiguration from '../../routing/routeConfiguration';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import IconCard from '../../components/SavedCardDetails/IconCard/IconCard';
import ConfirmAppleForm from './AppleConfirmFrom/ConfirmAppleForm';
import {
  trackSignupBoxOpened,
  trackSignupTypeSelected,
  SIGNUP_METHOD_EMAIL,
  SIGNUP_METHOD_GOOGLE,
  SIGNUP_METHOD_FACEBOOK,
  SIGNUP_METHOD_APPLE,
} from '../../analytics/signupFunnel';

// Social login buttons are needed by AuthenticationForms
export const SocialLoginButtonsMaybe = props => {
  const routeConfiguration = useRouteConfiguration();
  const { isLogin, showFacebookLogin, showGoogleLogin, from, userType } = props;
  const showSocialLogins = showFacebookLogin || showGoogleLogin;

  const renderAppleButton = props => (
    <button
      type="button"
      className={css.appleSignUp}
      {...props}
    >
      <span>
        <span className={css.appleLogo}>
          <IconCard brand="applelogo" />
        </span>

        <span className={css.appleButton}>
          {isLogin ? 'MIT APPLE FORTFAHREN' : 'MIT APPLE FORTFAHREN'}
        </span>
      </span>
    </button>
  );

  const getDataForSSORoutes = () => {
    const baseUrl = apiBaseUrl();

    // Default route where user is returned after successfull authentication
    const defaultReturn = pathByRouteName('LandingPage', routeConfiguration);

    // Route for confirming user data before creating a new user
    const defaultConfirm = pathByRouteName('ConfirmPage', routeConfiguration);

    const queryParams = new URLSearchParams({
      ...(defaultReturn ? { defaultReturn } : {}),
      ...(defaultConfirm ? { defaultConfirm } : {}),
      // Route where the user should be returned after authentication
      // This is used e.g. with EditListingPage and ListingPage
      ...(from ? { from } : {}),
      // The preselected userType needs to be saved over the visit to identity provider's service
      ...(userType ? { userType } : {}),
    });

    return { baseUrl, queryParams: queryParams.toString() };
  };

  // The same buttons are shown in the login view - only count picks made while signing up.
  const trackSelectedIfSignup = method => {
    if (!isLogin) {
      trackSignupTypeSelected(method);
    }
  };

  const authWithFacebook = () => {
    trackSelectedIfSignup(SIGNUP_METHOD_FACEBOOK);
    const { baseUrl, queryParams } = getDataForSSORoutes();
    window.location.href = `${baseUrl}/api/auth/facebook?${queryParams}`;
  };

  const authWithGoogle = () => {
    trackSelectedIfSignup(SIGNUP_METHOD_GOOGLE);
    const { baseUrl, queryParams } = getDataForSSORoutes();
    window.location.href = `${baseUrl}/api/auth/google?${queryParams}`;
  };

    const appleLoginCallback = async data => {   
      console.log(data, '*** *** => data');
       
    const { id_token } = (data && data.authorization) || {};
    const userExists = await checkUserExistApi({ id_token });
    // if (userExists.user && userExists.user?.id) {
    //   handleAppleLogin(id_token);
    // } else {
    //   onCheckAppleMailId(id_token).then(checkMailRes => {
    //     setIdpToken(id_token);
    //     handleModel(checkMailRes.status);
    //   });
    // }
  };

  return showSocialLogins ? (
    <div className={css.idpButtons}>
      <div className={css.socialTitle}>
        {isLogin ? (
          <FormattedMessage id="AuthenticationPage.socialTitleLogin" />
        ) : (
          <FormattedMessage id="AuthenticationPage.socialTitleSignup" />
        )}
      </div>

      {showFacebookLogin ? (
        <div className={css.socialButtonWrapper}>
          <SocialLoginButton onClick={() => authWithFacebook()}>
            <span className={css.buttonIcon}>{FacebookLogo}</span>
            {isLogin ? (
              <FormattedMessage id="AuthenticationPage.loginWithFacebook" />
            ) : (
              <FormattedMessage id="AuthenticationPage.signupWithFacebook" />
            )}
          </SocialLoginButton>
        </div>
      ) : null}

      {showGoogleLogin ? (
        <div className={css.socialButtonWrapper}>
          <SocialLoginButton onClick={() => authWithGoogle()}>
            <span className={css.buttonIcon}>
              <GoogleIcon className={css.GoogleIcon} />
            </span>
            {isLogin ? (
              <FormattedMessage id="AuthenticationPage.loginWithGoogle" />
            ) : (
              <FormattedMessage id="AuthenticationPage.signupWithGoogle" />
            )}
          </SocialLoginButton>
        </div>
      ) : null}
      <div className={css.appleLogin}>
        <AppleLogin
          clientId={"com.onrender.kitts.signin"}
          redirectURI="https://www.kitts.de/apple/callback"
          responseType={"code id_token"}
          responseMode={"form_post"}
          scope={"name email"}
          usePopup={false}
          // Apple echoes this back verbatim as `state` in the POST to redirectURI
          // (server/index.js '/apple/callback'), which is how we get the page the
          // user started from back to AppleCallbackPage after auth - the same "from"
          // mechanism Facebook/Google login use via their own `state` param above.
          // react-apple-login builds the authorize URL without encoding `state`
          // itself, so we encode it here and decode it again server-side.
          state={from ? encodeURIComponent(from) : ''}
          callback={appleLoginCallback}
          render={props => (
            <SocialLoginButton
              onClick={e => {
                trackSelectedIfSignup(SIGNUP_METHOD_APPLE);
                props.onClick(e);
              }}
            >
              <span className={css.buttonIcon}>
                <AppleIcon className={css.AppleIcon} />
              </span>

              <span className={css.appleText}>
                MIT APPLE FORTFAHREN
              </span>
            </SocialLoginButton>
          )}
        />
      </div>
    </div>
  ) : null;
};

const getNonUserFieldParams = (values, userFieldConfigs) => {
  const userFieldKeys = userFieldConfigs.map(({ scope, key }) => addScopePrefix(scope, key));

  return Object.entries(values).reduce((picked, [key, value]) => {
    const isUserFieldKey = userFieldKeys.includes(key);

    return isUserFieldKey
      ? picked
      : {
        ...picked,
        [key]: value,
      };
  }, {});
};

// Tabs for SignupForm and LoginForm
export const AuthenticationForms = props => {
  const {
    isLogin,
    showFacebookLogin,
    showGoogleLogin,
    userType,
    from,
    submitLogin,
    loginError,
    idpAuthError,
    signupError,
    authInProgress,
    submitSignup,
    termsAndConditions,
    onResendVerificationEmail,
    sendVerificationEmailInProgress,
  } = props;
  const config = useConfiguration();
  const { userFields, userTypes = [] } = config.user;
  const preselectedUserType = userTypes.find(conf => conf.userType === userType)?.userType || null;

  // Full /signup page (the topbar modal tracks this itself in Topbar.js).
  useEffect(() => {
    if (!isLogin) {
      trackSignupBoxOpened();
    }
  }, [isLogin]);

  const fromMaybe = from ? { from } : null;
  const signupRouteName = !!preselectedUserType ? 'SignupForUserTypePage' : 'SignupPage';
  const userTypeMaybe = preselectedUserType ? { userType: preselectedUserType } : null;
  const fromState = { state: { ...fromMaybe, ...userTypeMaybe } };
  const tabs = [
    {
      text: (
        <Heading as={!isLogin ? 'h1' : 'h2'} rootClassName={css.tab}>
          <FormattedMessage id="AuthenticationPage.signupLinkText" />
        </Heading>
      ),
      selected: !isLogin,
      linkProps: {
        name: signupRouteName,
        params: userTypeMaybe,
        to: fromState,
      },
    },
    {
      text: (
        <Heading as={isLogin ? 'h1' : 'h2'} rootClassName={css.tab}>
          <FormattedMessage id="AuthenticationPage.loginLinkText" />
        </Heading>
      ),
      selected: isLogin,
      linkProps: {
        name: 'LoginPage',
        to: fromState,
      },
    },
  ];

  const handleSubmitSignup = values => {
    // The email form is shown straight away on this page, so submitting it is the pick.
    trackSignupTypeSelected(SIGNUP_METHOD_EMAIL);
    const {
      userType,
      email,
      password,
      passwordConfirm,
      fullname,
      username,
      displayName,
      marketingConsent,
      ...rest
    } = values;
    const displayNameMaybe = displayName ? { displayName: displayName.trim() } : {};

    // Split full name to first and last name for backend compatibility
    const full = (fullname || '').trim();
    const [firstNameRaw, ...restNameParts] = full.split(/\s+/).filter(Boolean);
    const lastNameRaw = restNameParts.join(' ');
    const firstName = firstNameRaw || '';
    const lastName = lastNameRaw || '';

    const params = {
      email,
      password,
      firstName,
      lastName,
      ...displayNameMaybe,
      publicData: {
        userType,
        username: (username || '').trim(),
        ...pickUserFieldsData(rest, 'public', userType, userFields),
      },
      privateData: {
        ...pickUserFieldsData(rest, 'private', userType, userFields),
      },
      protectedData: {
        ...pickUserFieldsData(rest, 'protected', userType, userFields),
        ...getNonUserFieldParams(rest, userFields),
      },
      marketingConsent: !!marketingConsent,
    };

    submitSignup(params);
  };

  const loginErrorMessage = (
    <div className={css.error}>
      <FormattedMessage id="AuthenticationPage.loginFailed" />
    </div>
  );

  const idpAuthErrorMessage = (
    <div className={css.error}>
      <FormattedMessage id="AuthenticationPage.idpAuthFailed" />
    </div>
  );

  const signupErrorMessage = (
    <div className={css.error}>
      {isSignupEmailTakenError(signupError) ? (
        <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
      ) : (
        <FormattedMessage id="AuthenticationPage.signupFailed" />
      )}
    </div>
  );

  const loginOrSignupError =
    isLogin && !!idpAuthError
      ? idpAuthErrorMessage
      : !isLogin && !!signupError
        ? signupErrorMessage
        : null;

  return (
    <div className={css.content}>
      <LinkTabNavHorizontal className={css.tabs} tabs={tabs} />
      {loginOrSignupError}

      {isLogin ? (
        <LoginForm
          className={css.loginForm}
          onSubmit={submitLogin}
          inProgress={authInProgress}
          loginError={loginError}
          onResendVerificationEmail={onResendVerificationEmail}
          sendVerificationEmailInProgress={sendVerificationEmailInProgress}
        />
      ) : (
        <SignupForm
          className={css.signupForm}
          onSubmit={handleSubmitSignup}
          inProgress={authInProgress}
          termsAndConditions={termsAndConditions}
          preselectedUserType={preselectedUserType}
          userTypes={userTypes}
          userFields={userFields}
        />
      )}

      <SocialLoginButtonsMaybe
        isLogin={isLogin}
        showFacebookLogin={showFacebookLogin}
        showGoogleLogin={showGoogleLogin}
        {...fromMaybe}
        {...userTypeMaybe}
      />
    </div>
  );
};

// Form for confirming information from IdP (e.g. Facebook)
// This is shown before new user is created to Marketplace API
const ConfirmIdProviderInfoForm = props => {
  const {
    userType,
    authInfo,
    authInProgress,
    confirmError,
    submitSingupWithIdp,
    termsAndConditions,
    isAuthenticated,
  } = props;
  const config = useConfiguration();
  const { userFields, userTypes } = config.user;
  const preselectedUserType = userTypes.find(conf => conf.userType === userType)?.userType || null;
  const dispatch = useDispatch()

  const idp = authInfo ? authInfo.idpId.replace(/^./, str => str.toUpperCase()) : null;


  const handleSubmitConfirm = values => {
    if (!authInfo) {
      console.error('authInfo missing – cannot submit IdP signup');
      return;
    }
    const { idpToken, email, firstName, lastName, idpId } = authInfo;
    if (!idpToken || !idpId) {
      console.error('Missing idpToken or idpId in authInfo', authInfo);
      return;
    }


    const {
      userType,
      email: newEmail,
      fullName,
      displayName,
      marketingConsent,
      terms,
      ...rest
    } = values;


    // Split fullName into firstName and lastName
    const [newFirstName, ...restName] = fullName ? fullName.trim().split(' ') : [firstName];
    const newLastName = restName.length > 0 ? restName.join(' ') : lastName || '-';

    const displayNameMaybe = displayName ? { displayName: displayName.trim() } : {};

    // Pass email, firstName or lastName to Marketplace API only if user has edited them
    const authParams = {
      ...(newEmail !== email && { email: newEmail }),
      ...(newFirstName !== firstName && { firstName: newFirstName }),
      ...(newLastName !== lastName && { lastName: newLastName }),
    };

    // Pass other values as extended data according to user field configuration
    const extendedDataMaybe = !isEmpty(rest)
      ? {
        publicData: {
          userType,
          fullname: fullName,
          ...pickUserFieldsData(rest, 'public', userType, userFields),
        },
        privateData: {
          ...pickUserFieldsData(rest, 'private', userType, userFields),
        },
        protectedData: {
          ...pickUserFieldsData(rest, 'protected', userType, userFields),
          ...getNonUserFieldParams(rest, userFields),
          ...(typeof marketingConsent !== 'undefined'
            ? { marketingConsent: !!marketingConsent }
            : {}),
          ...(Array.isArray(terms) && terms.includes('tos-and-privacy')
            ? { termsAccepted: true }
            : {}),
        },
      }
      : {
        publicData: {
          userType,
          fullname: fullName,
        },
        protectedData: {
          ...(typeof marketingConsent !== 'undefined'
            ? { marketingConsent: !!marketingConsent }
            : {}),
          ...(Array.isArray(terms) && terms.includes('tos-and-privacy')
            ? { termsAccepted: true }
            : {}),
        },
      };

    const payload = {
      idpToken,
      idpId,
      ...authParams,
      ...displayNameMaybe,
      ...extendedDataMaybe,
    };


    if (marketingConsent) {
      if (authInfo?.email) {
        dispatch(updateField('email', authInfo.email));
        dispatch(updateField('firstName', authInfo.firstName || ''));
        dispatch(subscribeNewsletter());
      } else if (newEmail) {
        dispatch(updateField('email', newEmail));
        dispatch(updateField('firstName', newFirstName || ''));
        dispatch(subscribeNewsletter());
      }
    }


    // Clear the authInfo cookie to prevent stale data
    Cookies.remove('st-authinfo');

    submitSingupWithIdp(payload);
  };

  const confirmErrorMessage = confirmError ? (
    <div className={css.error}>
      {isSignupEmailTakenError(confirmError) ? (
        <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
      ) : (
        <FormattedMessage id="AuthenticationPage.signupFailed" />
      )}
    </div>
  ) : null;

  return (
    <div className={css.content}>
      <Heading as="h1" rootClassName={css.signupWithIdpTitle}>
        <GoogleIcon className={css.confirmTitleIcon} />
        <FormattedMessage id="AuthenticationPage.confirmSignupWithIdpTitle" values={{ idp }} />
      </Heading>

      <p className={css.confirmInfoText}>
        <FormattedMessage id="AuthenticationPage.confirmSignupInfoText" />
      </p>
      {confirmErrorMessage}
      <ConfirmSignupForm
        className={css.form}
        onSubmit={handleSubmitConfirm}
        inProgress={authInProgress}
        termsAndConditions={termsAndConditions}
        authInfo={authInfo}
        idp={idp}
        preselectedUserType="non-business-user"
        userTypes={userTypes}
        userFields={userFields}
      />
    </div>
  );
};

export const AuthenticationOrConfirmInfoForm = props => {
  const {
    tab,
    userType,
    authInfo,
    from,
    showFacebookLogin,
    showGoogleLogin,
    submitLogin,
    submitSignup,
    submitSingupWithIdp,
    authInProgress,
    loginError,
    idpAuthError,
    signupError,
    confirmError,
    termsAndConditions,
    onResendVerificationEmail,
    sendVerificationEmailInProgress,
    isAuthenticated,
  } = props;
  const isConfirm = tab === 'confirm';
  const isLogin = tab === 'login';

  return isConfirm ? (
    <ConfirmIdProviderInfoForm
      userType={userType}
      authInfo={authInfo}
      submitSingupWithIdp={submitSingupWithIdp}
      authInProgress={authInProgress}
      confirmError={confirmError}
      termsAndConditions={termsAndConditions}
      isAuthenticated={isAuthenticated}
    />
  ) : (
    <AuthenticationForms
      isLogin={isLogin}
      showFacebookLogin={showFacebookLogin}
      showGoogleLogin={showGoogleLogin}
      userType={userType}
      from={from}
      loginError={loginError}
      idpAuthError={idpAuthError}
      signupError={signupError}
      submitLogin={submitLogin}
      authInProgress={authInProgress}
      submitSignup={submitSignup}
      termsAndConditions={termsAndConditions}
      onResendVerificationEmail={onResendVerificationEmail}
      sendVerificationEmailInProgress={sendVerificationEmailInProgress}
    ></AuthenticationForms>
  );
};

const getAuthInfoFromCookies = () => {
  return Cookies.get('st-authinfo')
    ? JSON.parse(Cookies.get('st-authinfo').replace('j:', ''))
    : null;
};
const getAuthErrorFromCookies = () => {
  return Cookies.get('st-autherror')
    ? JSON.parse(Cookies.get('st-autherror').replace('j:', ''))
    : null;
};

const BlankPage = props => {
  const { schemaTitle, schemaDescription, scrollingDisabled, topbarClasses } = props;
  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer className={topbarClasses} />}
        footer={<Footer />}
      >
        <div className={css.spinnerContainer}>
          <IconSpinner />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

/**
 * The AuthenticationPage component.
 *
 * @component
 * @param {Object} props
 * @param {boolean} props.authInProgress - Whether the authentication is in progress
 * @param {propTypes.currentUser} props.currentUser - The current user
 * @param {boolean} props.isAuthenticated - Whether the user is authenticated
 * @param {propTypes.error} props.loginError - The login error
 * @param {propTypes.error} props.signupError - The signup error
 * @param {propTypes.error} props.confirmError - The confirm error
 * @param {Function} props.submitLogin - The login submit function
 * @param {Function} props.submitSignup - The signup submit function
 * @param {Function} props.submitSingupWithIdp - The signup with IdP submit function
 * @param {'login' | 'signup'| 'confirm'} props.tab - The tab to render
 * @param {boolean} props.sendVerificationEmailInProgress - Whether the verification email is in progress
 * @param {propTypes.error} props.sendVerificationEmailError - The verification email error
 * @param {Function} props.onResendVerificationEmail - The resend verification email function
 * @param {Function} props.onManageDisableScrolling - The manage disable scrolling function
 * @param {object} props.privacyAssetsData - The privacy assets data
 * @param {boolean} props.privacyFetchInProgress - Whether the privacy fetch is in progress
 * @param {propTypes.error} props.privacyFetchError - The privacy fetch error
 * @param {object} props.tosAssetsData - The terms of service assets data
 * @param {boolean} props.tosFetchInProgress - Whether the terms of service fetch is in progress
 * @param {propTypes.error} props.tosFetchError - The terms of service fetch error
 * @param {object} props.location - The location object
 * @param {object} props.params - The path parameters
 * @param {boolean} props.scrollingDisabled - Whether the scrolling is disabled
 * @returns {JSX.Element}
 */
export const AuthenticationPageComponent = props => {
  const [authInfo, setAuthInfo] = useState(getAuthInfoFromCookies());
  const [authError, setAuthError] = useState(getAuthErrorFromCookies());
  const [mounted, setMounted] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [idpToken, setIdpToken] = useState(false);

  const config = useConfiguration();
  const intl = useIntl();
  const history = useHistory();

  const idpId = process.env.REACT_APP_APPLE_IDP_ID;


  useEffect(() => {
    // Remove the autherror cookie once the content is saved to state
    // because we don't want to show the error message e.g. after page refresh
    if (authError) {
      Cookies.remove('st-autherror');
    }
    setMounted(true);
  }, []);

  const {
    authInProgress,
    currentUser,
    isAuthenticated,
    location,
    params: pathParams,
    loginError,
    scrollingDisabled,
    signupError,
    submitLogin,
    submitSignup,
    confirmError,
    submitSingupWithIdp,
    tab = 'signup',
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    onResendVerificationEmail,
    onSignupWithAppleIdp,
    onLoginWithAppleIdp,
    onCheckAppleMailId,
    confirmAppleInProgress,
    onManageDisableScrolling
  } = props;

  // History API has potentially state tied to this route
  // We have used that state to store previous URL ("from"),
  // so that use can be redirected back to that page after authentication.
  const locationFrom = location.state?.from || null;
  const authinfoFrom = authInfo?.from || null;
  const from = locationFrom || authinfoFrom || null;

  // If this LoginPage was opened due to visiting a verification link while unauthenticated,
  // redirect to LandingPage with login modal open and keep the original verify-email URL
  // in the redirect param so Topbar can handle the flow and auto-verify after login.
  if (!isAuthenticated && typeof from === 'string' && from.includes('/verify-email')) {
    const redirectParam = encodeURIComponent(from);
    // Use history.replace to avoid back button returning to /login loop
    props.history.replace(`/?login=open&redirect=${redirectParam}`);
    return null;
  }

  const isConfirm = tab === 'confirm';

  const userTypeInPushState = location.state?.userType || null;
  const userTypeInAuthInfo = isConfirm && authInfo?.userType ? authInfo?.userType : null;
  const userType = pathParams?.userType || userTypeInPushState || userTypeInAuthInfo || null;

  const { userTypes = [] } = config.user;
  const preselectedUserType = userTypes.find(conf => conf.userType === userType)?.userType || null;
  const show404 = userType && !preselectedUserType;

  const user = ensureCurrentUser(currentUser);
  const currentUserLoaded = !!user.id;
  const isLogin = tab === 'login';

  // We only want to show the email verification dialog in the signup
  // tab if the user isn't being redirected somewhere else
  // (i.e. `from` is present). We must also check the `emailVerified`
  // flag only when the current user is fully loaded.
  const pending = props.pendingEmailVerification;
  const showEmailVerification =
    (!isLogin && currentUserLoaded && !user.attributes.emailVerified) || (!!pending && !isLogin);

  const marketplaceName = config.marketplaceName;
  const schemaTitle = isLogin
    ? intl.formatMessage({ id: 'AuthenticationPage.schemaTitleLogin' }, { marketplaceName })
    : intl.formatMessage({ id: 'AuthenticationPage.schemaTitleSignup' }, { marketplaceName });
  const schemaDescription = isLogin
    ? intl.formatMessage({ id: 'AuthenticationPage.schemaDescriptionLogin' }, { marketplaceName })
    : intl.formatMessage({ id: 'AuthenticationPage.schemaDescriptionSignup' }, { marketplaceName });
  const topbarClasses = classNames({
    [css.hideOnMobile]: showEmailVerification,
  });

  const isUnsafeFrom =
    typeof from === 'string' &&
    (/(^\/?$)|[?&](login|signup)=open/.test(from) || /\/login|\/signup|\/confirm/.test(from));

  const shouldRedirectToFrom =
    isAuthenticated && currentUserLoaded && !!from && !isUnsafeFrom && !showEmailVerification;
  const shouldRedirectToLandingPage =
    isAuthenticated && currentUserLoaded && !showEmailVerification && !shouldRedirectToFrom;


  if (!mounted && shouldRedirectToLandingPage) {
    // Show a blank page for already authenticated users,
    // when the first rendering on client side is not yet done
    // This is done to avoid hydration issues when full page load is happening.
    return (
      <BlankPage
        schemaTitle={schemaTitle}
        schemaDescription={schemaDescription}
        topbarClasses={topbarClasses}
      />
    );
  }

  if (shouldRedirectToFrom) {
    // Already authenticated, redirect back to the page the user tried to access
    return <Redirect to={from} />;
  } else if (shouldRedirectToLandingPage) {
    // Already authenticated, redirect to the landing page (this was direct access to /login or /signup)
    return <NamedRedirect name="LandingPage" />;
  } else if (show404) {
    // User type not found, show 404
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  const resendErrorTranslationId = isTooManyEmailVerificationRequestsError(
    sendVerificationEmailError
  )
    ? 'AuthenticationPage.resendFailedTooManyRequests'
    : 'AuthenticationPage.resendFailed';
  const resendErrorMessage = sendVerificationEmailError ? (
    <p className={css.error}>
      <FormattedMessage id={resendErrorTranslationId} />
    </p>
  ) : null;


  const handleModel = checkMail => setOpenModal(checkMail);

  const handleAppleLogin = async id_token => {
    // const { id_token: idpToken } = (values && values.authorization) || {};
    const idpToken = id_token;
    if (idpToken) {
      onLoginWithAppleIdp({ idpToken, idpId }).then(res => {
        const status = res.status;
        setOpenModal(false)
        if (status == 'SUCCESS') {
          history.push(
            createResourceLocatorString(
              'VerificationAccountSettings',
              routeConfiguration(),
              {},
              {}
            )
          );
        } else {
          console.log('Account not found please sign up *** *** => ');

        }
      });
    }
  };



  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
        description: schemaDescription,
      }}
    >
      <LayoutSingleColumn
        mainColumnClassName={css.layoutWrapperMain}
        topbar={<TopbarContainer className={topbarClasses} />}
        footer={<Footer />}
      >
        <ResponsiveBackgroundImageContainer
          className={css.root}
          childrenWrapperClassName={css.contentContainer}
          as="section"
          image={config.branding.brandImage}
          sizes="100%"
          useOverlay
        >
          {showEmailVerification ? (
            <EmailVerificationInfo
              name={(pending && pending.firstName) || user.attributes.profile.firstName}
              email={
                <span className={css.email}>
                  {(pending && pending.email) || user.attributes.email}
                </span>
              }
              onResendVerificationEmail={() =>
                pending && pending.email && pending.password
                  ? onResendVerificationEmail(pending.email, pending.password)
                  : onResendVerificationEmail()
              }
              resendErrorMessage={resendErrorMessage}
              sendVerificationEmailInProgress={sendVerificationEmailInProgress}
            />
          ) : (
            <>
              <AuthenticationOrConfirmInfoForm
                tab={tab}
                userType={userType}
                authInfo={authInfo}
                from={from}
                showFacebookLogin={!!process.env.REACT_APP_FACEBOOK_APP_ID}
                showGoogleLogin={!!process.env.REACT_APP_GOOGLE_CLIENT_ID}
                submitLogin={submitLogin}
                submitSignup={submitSignup}
                submitSingupWithIdp={submitSingupWithIdp}
                authInProgress={authInProgress}
                loginError={loginError}
                idpAuthError={authError}
                signupError={signupError}
                confirmError={confirmError}
                isAuthenticated={isAuthenticated}
                termsAndConditions={<TermsAndConditions intl={intl} />}
              />
            </>

          )}
        </ResponsiveBackgroundImageContainer>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { isAuthenticated, loginError, signupError, confirmError } = state.auth;
  const { currentUser, sendVerificationEmailInProgress, sendVerificationEmailError } = state.user;

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    loginError,
    scrollingDisabled: isScrollingDisabled(state),
    signupError,
    confirmError,
    sendVerificationEmailInProgress,
    sendVerificationEmailError,
    pendingEmailVerification: state.auth?.pendingEmailVerification,
  };
};

const mapDispatchToProps = dispatch => ({
  submitLogin: ({ email, password }) => dispatch(login(email, password)),
  submitSignup: params => dispatch(signup(params)),
  submitSingupWithIdp: params => dispatch(signupWithIdp(params)),
  onResendVerificationEmail: (email, password) =>
    email && password
      ? dispatch(
        require('../../ducks/user.duck').resendVerificationWithCredentials(email, password)
      )
      : dispatch(sendVerificationEmail()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  onSignupWithAppleIdp: params => dispatch(signupWithAppleIdp(params)),
  onLoginWithAppleIdp: params => dispatch(loginWithAppleIdp(params)),
  onCheckAppleMailId: params => dispatch(checkAppleMailId(params)),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AuthenticationPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AuthenticationPageComponent);

export default AuthenticationPage;
